import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Navbar } from '@/components/Navbar';
import { useUser } from 'utils/useUser';

export default function Layout({ children }) {
  const { user, userFinderLoaded } = useUser();
  const Toaster = dynamic(() =>
    import("react-hot-toast").then((module) => module.Toaster)
  );
  const Footer = dynamic(() => import('@/components/Footer'));
  const AdminMobileNav = dynamic(() => import('@/components/AdminNavbar/AdminMobileNav'));
  const AdminDesktopNav = dynamic(() => import('@/components/AdminNavbar/AdminDesktopNav'));
  const SimpleNav = dynamic(() => import('@/components/SimpleNav'));
  const StripeDisconnectNotice = dynamic(() => import('@/components/StripeDisconnectNotice'));
  const router = useRouter();
  let defaultPage = true;
  let dashboardPage = false;
  let simplePage = false;
  let campaignCustomizer = false;

  const isShopifyPage = router.pathname === '/shopify';

  if(router.pathname.indexOf('/dashboard') === -1 && router.pathname.indexOf('/dashboard/add-company') === -1 && router.pathname.indexOf('/dashboard/create-team') === -1){
    dashboardPage = false;
    simplePage = false;
    campaignCustomizer = false;
    defaultPage = true;
  }

  if(router.pathname === '/dashboard/add-company' || router.pathname === '/dashboard/create-team'){
    defaultPage = false;
    dashboardPage = false;
    campaignCustomizer = false;
    simplePage = true;
  }

  if(router.pathname.indexOf('/dashboard') > -1 && simplePage !== true){
    defaultPage = false;
    simplePage = false;
    campaignCustomizer = false;
    dashboardPage = true;
  }

  if(router.pathname.indexOf('/dashboard') > -1 && router.pathname.indexOf('/campaigns') > -1 && router.pathname.indexOf('/customize') > -1){
    defaultPage = false;
    dashboardPage = false;
    simplePage = false;
    campaignCustomizer = true;
  }

  if(dashboardPage === true){
    useEffect(() => {
      if(userFinderLoaded){
        if (!user) {
          const embedded = router.query?.embedded;
          router.replace(embedded === '1' ? '/signin?nopass=1' : '/signin');
        }
      }
    }, [userFinderLoaded, user]);

    useEffect(() => {
      const isEmbedded = router?.query?.embedded === '1' || router?.query?.embedded === 'true';
      if (!isEmbedded) return;

      const onStart = (url) => {
        console.info('[ui][router] routeChangeStart', {
          from: router.asPath,
          to: url,
        });
      };
      const onComplete = (url) => {
        console.info('[ui][router] routeChangeComplete', {
          to: url,
        });
      };
      const onError = (err, url) => {
        console.error('[ui][router] routeChangeError', {
          to: url,
          message: err?.message || String(err),
          cancelled: !!err?.cancelled,
        });
      };

      const onDocumentClick = (event) => {
        const target = event?.target;
        if (!target || typeof target.closest !== 'function') return;

        const anchor = target.closest('a');
        const button = target.closest('button');
        if (!anchor && !button) return;

        console.info('[ui][click]', {
          asPath: router.asPath,
          anchorHref: anchor?.getAttribute?.('href') || null,
          buttonType: button?.getAttribute?.('type') || null,
          buttonText: (button?.textContent || '').trim().slice(0, 80) || null,
          defaultPrevented: !!event.defaultPrevented,
        });
      };

      router.events.on('routeChangeStart', onStart);
      router.events.on('routeChangeComplete', onComplete);
      router.events.on('routeChangeError', onError);
      document.addEventListener('click', onDocumentClick, true);

      return () => {
        router.events.off('routeChangeStart', onStart);
        router.events.off('routeChangeComplete', onComplete);
        router.events.off('routeChangeError', onError);
        document.removeEventListener('click', onDocumentClick, true);
      };
    }, [router]);
  }

  return (
    <>
      <>
        <Toaster
          position="bottom-center"
          reverseOrder={true}
          gutter={20}
          toastOptions={{
            className: '',
            duration: 5000,
            style: {
              background: '#fff',
              color: '#111827',
            },
            // Default options for specific types
            success: {
              theme: {
                primary: 'green',
                secondary: 'black',
              },
            },
            error: {
              style: {
                background: '#DC2626',
                color: 'white',
              },
            },
          }}
        />
        {defaultPage && !isShopifyPage && <Navbar />}
        {
          simplePage === true &&
          <SimpleNav/>
        }
        {
          defaultPage === true ?
            <main id="skip">{children}</main>
          : simplePage === true ?
            <main id="skip">{children}</main>
          : dashboardPage === true ?
            <div className="h-screen flex overflow-hidden">
              <AdminDesktopNav/>
              <div className="flex-1 overflow-auto focus:outline-none relative">
                {/*<StripeDisconnectNotice/>*/}
                <AdminMobileNav/>
                <main className="flex-1 pb-8 z-0 overflow-y-auto">
                  <>
                    {children}
                  </>
                </main>
              </div>
            </div>
          : campaignCustomizer === true ?
            <div className="h-screen flex overflow-hidden relative">
              <div className="flex-1 overflow-auto focus:outline-none">
                <main className="flex-1 z-0 overflow-y-auto">
                  <>
                    {children}
                  </>
                </main>
              </div>
            </div>
          : <main id="skip">{children}</main>
        }
        {defaultPage && !isShopifyPage && <Footer />}
      </>
    </>
  );
}
